import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
// import { identicon } from 'identicon';
// import { fs } from 'fs'
import { MatGridListModule, MatDialog, MatDialogConfig } from '@angular/material/';
import { HelperService } from '../service/helper/helper.service';
import { ModalComponent } from '../modal/modal.component';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  show = false;
  avatar:any;
  address = this.helper.accountList[this.helper.slectedAddress];
  public modifiedAddress = this.address.substring(0,6)+"..."+this.address.substr(this.address.length - 4);
  balance = this.helper.accountListBalance[this.address]
  symbol = this.helper.currentAccount.symbol;


  constructor( public dialog: MatDialog, public router: Router, public helper: HelperService) { }

  async ngOnInit() {

    this.balance =  await this.helper.checkBalance();

    console.log(this.balance)


    this.helper.selAcc.subscribe(x=>{
      console.log(this.helper.accountListBalance)
      this.address = this.helper.accountList[this.helper.slectedAddress];
      this.modifiedAddress = this.address.substring(0,6)+"..."+this.address.substr(this.address.length - 4);
      this.balance = this.helper.accountListBalance[this.address]
      this.symbol = this.helper.currentAccount.symbol;
    })
  }

  route(linkName) {
    const link = ['/' + linkName];
    this.router.navigate(link);
  }
  // txHistory() {
  //   this.router.navigate(['txhistory'])
  // }

  openDialog() {

    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;

    dialogConfig.data = {
      id: 1,
      title: 'Angular For Beginners'
    };
    dialogConfig.minWidth='300px'
    // this.dialog.dialogContainer = {

    // }

    dialogConfig.position = {
      top:'67px',
      right: '0',

    };

    this.dialog.open(ModalComponent, dialogConfig);
}

  showHide() {
    this.show = !this.show;
  }



}
